<template>
  <!--头部-->
  <header class="mm-header">
    <h1 class="header">
      <a href="http://music.imyjs.cn/" target="_blank">听你想听 在线音乐播放器</a>
      <!-- <img
        v-if="visitorBadge"
        :src="visitorBadge"
        alt="累计访问数"
        class="visitor"
        onerror="this.style.display='none'"
      /> -->
    </h1>
    <dl class="user">
      <template v-if="uid">
        <router-link class="user-info" to="/music/userlist" tag="dt">
          <img class="avatar" :src="`${user.avatar}?param=50y50`" />
          <span>{{ user.username }}</span>
        </router-link>
        <dd class="user-btn" @click="openDialog(2)">退出</dd>
      </template>
      <dd v-else class="user-btn" @click="openDialog(0)">登录/注册</dd>
    </dl>
    <!--登录-->
    <mm-dialog
      ref="loginDialog"
      head-text="登录"
      confirm-btn-text="登录"
      cancel-btn-text="关闭"
      @confirm="login"
    >
      <div class="mm-dialog-text">
        <input
          v-model.trim="loginUser.username"
          class="mm-dialog-input"
          autofocus
          placeholder="请输入用户名/邮箱"
          @keyup.enter="login"
        />
        <input
          v-model.trim="loginUser.password"
          class="mm-dialog-input"
          autofocus
          type="password"
          placeholder="请输入密码"
          @keyup.enter="login"
        />
      </div>
      <div slot="btn" @click="openDialog(1)">去注册</div>
    </mm-dialog>
    <!--注册-->
    <mm-dialog
      ref="registerDialog"
      head-text="注册"
      confirm-btn-text="注册"
      cancel-btn-text="关闭"
      @confirm="register"
    >
      <div class="mm-dialog-text">
        <input
          v-model.trim="registerUser.username"
          class="mm-dialog-input"
          autofocus
          placeholder="请输入用户名"
          @keyup.enter="register"
        />
        <input
          v-model.trim="registerUser.password"
          class="mm-dialog-input"
          autofocus
          type="password"
          placeholder="请输入密码"
          @keyup.enter="register"
        />
        <input
          v-model.trim="registerUser.emailUrl"
          class="mm-dialog-input"
          style="width: 60%"
          type="email"
          autofocus
          placeholder="请输入邮箱"
          @keyup.enter="register"
        />
        <button @click="sendEmailCode">获取验证码</button>
        <input
          v-model.trim="registerUser.emailCode"
          class="mm-dialog-input"
          type="number"
          autofocus
          placeholder="请输入邮箱验证码"
          @keyup.enter="register"
        />
      </div>
      <div slot="btn" @click="openDialog(0)">去登陆</div>
    </mm-dialog>
    <!--退出-->
    <mm-dialog ref="outDialog" body-text="确定退出当前用户吗？" @confirm="out" />
  </header>
</template>

<script>
import { getUserPlaylist, getEmailCode, toRegister, toLogin, getUserInfo, logout } from 'api'
import { mapGetters, mapActions } from 'vuex'
import MmDialog from 'base/mm-dialog/mm-dialog'
// import { toHttps } from '@/utils/util'
import { VISITOR_BADGE_ID } from '@/config'

export default {
  name: 'MmHeader',
  components: {
    MmDialog
  },
  data() {
    return {
      registerUser: {
        username: '',
        password: '',
        emailUrl: '',
        emailCode: ''
      },
      loginUser: {
        username: '',
        password: ''
      },
      user: {} // 用户数据
      // uidValue: '' // 记录用户 UID
    }
  },
  computed: {
    visitorBadge() {
      if (VISITOR_BADGE_ID) {
        return `https://visitor-badge.laobi.icu/badge?left_color=transparent&right_color=transparent&page_id=${VISITOR_BADGE_ID}`
      }
      return ''
    },
    ...mapGetters(['uid'])
  },
  created() {
    // this.uid && this._getUserPlaylist(this.uid)
    if (window.localStorage.getItem('userInfo') != null) {
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      this.user = userInfo.user
    }
  },
  methods: {
    // 打开对话框
    openDialog(key) {
      switch (key) {
        case 0:
          this.$refs.loginDialog.show()
          this.$refs.registerDialog.hide()
          break
        case 1:
          this.$refs.loginDialog.hide()
          this.$refs.registerDialog.show()
          break
        case 2:
          this.$refs.outDialog.show()
          break
        case 3:
          this.$refs.loginDialog.hide()
          break
      }
    },
    // 退出登录
    out() {
      logout().then((resp) => {
        this.user = {}
        this.setUid(null)
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userInfo')
        this.$mmToast(resp.msg)
      })
      // this.$mmToast('退出成功！')
    },
    // 登录
    login() {
      if (this.loginUser.username == '') {
        this.$mmToast('请输入用户名！')
        this.openDialog(0)
        return
      }
      if (this.loginUser.password == '') {
        this.$mmToast('请输入密码！')
        this.openDialog(0)
        return
      }
      toLogin(this.loginUser).then((resp) => {
        if (resp.code == 200) {
          window.localStorage.setItem('token', resp.data)
          this.$mmToast(resp.msg)
          this.$refs.loginDialog.hide()
          let tokenObj = {
            Authorization: resp.data
          }
          getUserInfo(tokenObj).then((resp) => {
            this.user = resp.data.user
            // this.uidValue = resp.data.user.id
            this.setUid(resp.data.user.id)
            window.localStorage.setItem('userInfo', JSON.stringify(resp.data))
            setTimeout(() => {
              this.$mmToast(`${this.user.username} 欢迎您的使用！`)
            }, 200)
          })
        } else {
          this.$mmToast(resp.msg)
        }
      })
      // this._getUserPlaylist(this.uidValue)
    },
    // 注册
    register() {
      if (this.registerUser.username == '') {
        this.$mmToast('请输入用户名！')
        this.openDialog(1)
        return
      }
      if (this.registerUser.password == '') {
        this.$mmToast('请输入密码！')
        this.openDialog(1)
        return
      }
      if (this.registerUser.emailUrl == '') {
        this.$mmToast('请输入邮箱地址！')
        this.openDialog(1)
        return
      }
      if (this.registerUser.emailCode == '') {
        this.$mmToast('请输入验证码！')
        this.openDialog(1)
        return
      }
      toRegister(this.registerUser).then((resp) => {
        if (resp.code == 200) {
          this.$mmToast(resp.msg)
          this.registerUser.username = ''
          this.registerUser.password = ''
          this.registerUser.emailUrl = ''
          this.registerUser.emailCode = ''
          this.openDialog(0)
        } else {
          this.$mmToast(resp.msg)
          this.openDialog(1)
        }
      })
    },
    // 获取邮箱验证码
    sendEmailCode() {
      if (this.registerUser.emailUrl == '') {
        this.$mmToast('请输入邮箱地址！')
        return
      }
      if (this.registerUser.username == '') {
        this.$mmToast('请输入用户名！')
        return
      }
      getEmailCode(this.registerUser.emailUrl, this.registerUser.username).then((resp) => {
        if (resp.code === 200) {
          this.$mmToast(resp.msg)
        } else {
          this.$mmToast(resp.msg)
        }
      })
    },
    // 获取用户数据
    // _getUserPlaylist(uid) {
    //   getUserPlaylist(uid).then((songs) => {
    //     if (songs.length === 0) {
    //       this.$mmToast(`您的歌单还没有歌曲呢~`)
    //       return
    //     }
    //     setTimeout(() => {
    //       this.$mmToast(`${this.user.nickname} 欢迎您的使用！`)
    //     }, 200)
    //   })
    // },
    ...mapActions(['setUid'])
  }
}
</script>

<style lang="less">
.mm-header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  @media (max-width: 768px) {
    background: @header_bg_color;
  }
  .header {
    .flex-center;
    line-height: 60px;
    color: @text_color_active;
    font-size: @font_size_large;
    @media (max-width: 768px) {
      padding-left: 15px;
      justify-content: flex-start;
    }
    @media (max-width: 414px) {
      font-size: @font_size_medium;
    }
    .visitor {
      margin-left: 6px;
      height: 20px;
      @media (max-width: 414px) {
        display: none;
      }
    }
  }
  .user {
    position: absolute;
    top: 50%;
    right: 15px;
    line-height: 30px;
    text-align: right;
    transform: translateY(-50%);
    &-info {
      float: left;
      margin-right: 15px;
      cursor: pointer;
      .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
      }
      span {
        margin-left: 10px;
        color: @text_color_active;
      }
    }
    &-btn {
      float: left;
      cursor: pointer;
      &:hover {
        color: @text_color_active;
      }
    }
    @media (max-width: 768px) {
      &-info {
        margin-right: 10px;
        span {
          display: none;
        }
      }
    }
  }
}
.mm-dialog-text {
  text-align: left;
  .mm-dialog-input {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 15px;
    border: 1px solid @btn_color;
    outline: 0;
    background: transparent;
    color: @text_color_active;
    font-size: @font_size_medium;
    box-shadow: 0 0 1px 0 #fff inset;
    &::placeholder {
      color: @text_color;
    }
  }
  a:hover {
    color: #d43c33;
  }
}
</style>
